import { List, Map } from 'immutable'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { TAB_TYPES } from '../lib/tab-utils'

export function filterChangedPathAC(state, changesPathProvided) {
  const rulesStatus = state.getIn(['project', 'Settings', 'ac', 'enabled'])
  if (!rulesStatus) {
    return changesPathProvided
  }
  try {
    if (!changesPathProvided || !changesPathProvided.length) {
      return changesPathProvided
    }
    const smartvParamID =
      state
        .getIn(['project', 'params'], List())
        .find((param) => param.get('isACParam') === true)
        ?.get?.('id') || '_'
    const smartvParameterValue = state.getIn(['params', smartvParamID], '')

    const rules = state.getIn(['project', 'Settings', 'ac', 'list'], List())

    let targetRule = rules.find((rule) => rule.get('value', '') === smartvParameterValue && rule.get('enabled'))
    const fallbackRule = rules.find((rule) => rule.get('isFallback') && rule.get('enabled'))
    if (!targetRule) {
      targetRule = fallbackRule
    }
    if (!targetRule) {
      return changesPathProvided
    }
    let resultPathProvided = []
    _.each(changesPathProvided, function (row) {
      let isInvisible = false
      _.each(row, function (uid) {
        if (targetRule.getIn(['rules', uid, 'visibility'], '') === 'hidden') {
          isInvisible = true
        } else if (recursiveParentInvisibleValidation(uid, state, targetRule)) {
          isInvisible = true
        }
      })
      if (!isInvisible) {
        resultPathProvided.push(row)
      }
    })
    return resultPathProvided
  } catch (err) {
    console.error(err)
  }
  return changesPathProvided
}

export function getACByState(state) {
  const rulesStatus = state.getIn(['project', 'Settings', 'ac', 'enabled'])
  if (!rulesStatus) {
    return null
  }
  try {
    const smartvParamID =
      state
        .getIn(['project', 'params'], List())
        .find((param) => param.get('isACParam') === true)
        ?.get?.('id') || '_'
    const smartvParameterValue = state.getIn(['params', smartvParamID], '')

    const rules = state.getIn(['project', 'Settings', 'ac', 'list'], List())

    let targetRule = rules.find((rule) => rule.get('value', '') === smartvParameterValue && rule.get('enabled'))
    const fallbackRule = rules.find((rule) => rule.get('isFallback') && rule.get('enabled'))
    if (!targetRule) {
      targetRule = fallbackRule
    }
    if (!targetRule) {
      return null
    }
    return targetRule
  } catch (err) {
    console.error(err)
  }
  return null
}

export function recursiveParentInvisibleValidation(uid, state, acRule) {
  let pageId = state.get('page')
  let elements
  if (state.getIn(['pages', pageId, 'Props', 'elements', uid])) {
    elements = state.getIn(['pages', pageId, 'Props', 'elements'])
  } else if (state.getIn(['project', 'Settings', 'elements', uid])) {
    elements = state.getIn(['project', 'Settings', 'elements'])
  }
  if (!elements) {
    return false
  }
  if (acRule.getIn(['rules', uid, 'visibility'], '') === 'hidden') {
    return true
  }

  let elem = elements.get(uid)
  let recursiveChkParent = (parent, elemUID) => {
    if (acRule.getIn(['rules', parent, 'visibility'], '') === 'hidden') {
      return true
    }

    if (TAB_TYPES.includes(elements.getIn([parent, 'type']))) {
      let elem = elements.get(parent)
      let isInvisible = false,
        isFoundElem = false
      elem.getIn(['props', 'lg', 'tabs'], List()).map((tab) => {
        if (tab && tab.get('children') && tab.get('children').indexOf(elemUID) > -1) {
          isFoundElem = true
        }
        if (!isInvisible && tab && tab.get('children') && tab.get('children').indexOf(elemUID) > -1) {
          if (acRule.getIn(['rules', `row:${parent}:${tab.get('id')}`, 'visibility'], '') === 'hidden') {
            isInvisible = true
          }
        }
      })
      if (isInvisible || !isFoundElem) {
        return true
      }
    } else if (elements.getIn([parent, 'type']) == 'Form') {
      let form = elements.getIn([parent])
      let children = form.getIn(['props', 'lg', 'children'], List()).toJS()
      let isInvisible = false
      _.each(children, function (row, rowID) {
        if (row) {
          _.each(row.children, function (col, colID) {
            if (col && col.children && !isInvisible) {
              if (col.children.indexOf(elemUID) > -1) {
                try {
                  if (acRule.getIn(['rules', `row:${parent}:${rowID}`, 'visibility'], '') === 'hidden') {
                    isInvisible = true
                  } else {
                    if (acRule.getIn(['rules', colID, 'visibility'], '') === 'hidden') {
                      isInvisible = true
                    } else {
                      if (acRule.getIn(['rules', `col:${parent}:${col.index}`, 'visibility'], '') === 'hidden') {
                        isInvisible = true
                      }
                    }
                  }
                } catch (err) {
                  console.error(err)
                }
              }
            }
          })
        }
      })

      if (isInvisible) {
        return true
      }
    }

    if (elements.getIn([parent, 'parent'])) {
      return recursiveChkParent(elements.getIn([parent, 'parent']), parent)
    }
    return false
  }
  if (elem && elem.get('parent')) {
    return recursiveChkParent(elem.get('parent'), uid)
  }
  return false
}

// filter rules related to access control
export function filterRulesAC(state, providedRules) {
  const rulesStatus = state.getIn(['project', 'Settings', 'ac', 'enabled'])
  if (!rulesStatus) {
    return providedRules
  }
  try {
    if (!providedRules || !providedRules.size) {
      return providedRules
    }
    const smartvParamID =
      state
        .getIn(['project', 'params'], List())
        .find((param) => param.get('isACParam') === true)
        ?.get?.('id') || '_'
    const smartvParameterValue = state.getIn(['params', smartvParamID], '')

    const rules = state.getIn(['project', 'Settings', 'ac', 'list'], List())

    let targetRule = rules.find((rule) => rule.get('value', '') === smartvParameterValue && rule.get('enabled'))
    const fallbackRule = rules.find((rule) => rule.get('isFallback') && rule.get('enabled'))
    if (!targetRule) {
      targetRule = fallbackRule
    }
    if (!targetRule) {
      return providedRules
    }
    let resultRules = providedRules.filter((row, key) => {
      const elemKey = String(key).split(':')
      let isVisible = true
      _.each(elemKey, function (uid) {
        if (targetRule.getIn(['rules', uid, 'visibility'], '') === 'hidden') {
          isVisible = false
        } else if (recursiveParentInvisibleValidation(uid, state, targetRule)) {
          isVisible = false
        }
      })
      return isVisible
    })
    return resultRules
  } catch (err) {
    console.error(err)
  }
  return providedRules
}

export function useACRule() {
  const isWebBuilder = useSelector((state) => state.get('isWebBuilder'))
  const rulesStatus = useSelector((state) => state.getIn(['project', 'Settings', 'ac', 'enabled']))
  const smartvParamID = useSelector(
    (state) =>
      state
        .getIn(['project', 'params'], List())
        .find((param) => param.get('isACParam') === true)
        ?.get?.('id') || '_'
  )
  const smartvParameterValue = useSelector((state) => (rulesStatus ? state.getIn(['params', smartvParamID], '') : ''))
  const rules = useSelector((state) => state.getIn(['project', 'Settings', 'ac', 'list'], List()))

  return useMemo(() => {
    let rule = Map()
    if (isWebBuilder) {
      return rule
    }
    if (rulesStatus) {
      //for now not have default rules
      // const defaultRule = rules.find(rule => rule.get('isDefault'))
      let targetRule = rules.find((rule) => rule.get('value', '') === smartvParameterValue && rule.get('enabled'))
      const fallbackRule = rules.find((rule) => rule.get('isFallback') && rule.get('enabled'))
      if (!targetRule) {
        targetRule = fallbackRule
      }
      if (targetRule) {
        rule = targetRule
        // } else if (defaultRule) {
        //     return defaultRule
      } else {
        rule = Map()
      }
    } else {
      rule = Map()
    }
    return rule
  }, [rules, smartvParameterValue, isWebBuilder])
}
